<nb-card class="adoption-modal">
  <nb-card-header>
    <h4>{{ 'dialogs.adoptionModal.headline' | translate }}</h4>
  </nb-card-header>

  <nb-card-body>
    <div class="adoption-modal__showcase">
      <app-agent-orb
        type="tutor"
        [size]="72"
        [mood]="solved ? 'happy' : 'idle'"
        class="adoption-modal__orb"
      ></app-agent-orb>

      <div class="adoption-modal__picture">
        <img [src]="quiz.image" alt="" class="adoption-modal__image" />

        <div
          *ngFor="let annotation of quiz.annotations"
          class="adoption-modal__annotation"
          [style.top.%]="annotation.top"
          [style.left.%]="annotation.left"
        >
          <span class="adoption-modal__annotation-title">{{ annotation.textKey | translate }}</span>
          <span *ngIf="annotation.subTextKey" class="adoption-modal__annotation-sub">
            {{ annotation.subTextKey | translate }}
          </span>
        </div>
      </div>

      <div
        class="adoption-modal__bubble"
        [class.adoption-modal__bubble--visible]="showBubble"
      >
        <p>{{ quiz.bubbleKey | translate }}</p>
      </div>
    </div>

    <hr class="adoption-modal__divider" />

    <div class="adoption-modal__quiz">
      <h5 class="adoption-modal__quiz-label">{{ 'dialogs.adoptionModal.quizLabel' | translate }}</h5>
      <p class="adoption-modal__question">{{ quiz.questionKey | translate }}</p>

      <div class="adoption-modal__options">
        <button
          *ngFor="let option of quiz.options; let i = index"
          type="button"
          class="adoption-modal__option"
          [class.adoption-modal__option--wrong]="attemptedWrong.has(i)"
          [class.adoption-modal__option--correct]="solved && option.correct"
          [disabled]="attemptedWrong.has(i) || solved"
          (click)="selectOption(i)"
        >
          {{ option.labelKey | translate }}
        </button>
      </div>

      <p class="adoption-modal__feedback adoption-modal__feedback--wrong" *ngIf="attemptedWrong.size && !solved">
        {{ 'dialogs.adoptionModal.wrongAnswer' | translate }}
      </p>
      <p class="adoption-modal__feedback adoption-modal__feedback--correct" *ngIf="solved">
        {{ 'dialogs.adoptionModal.correctAnswer' | translate }}
      </p>
    </div>
  </nb-card-body>
</nb-card>
